export default __webpack_public_path__ + "static/media/BP07.a98a0b03.jpg";